export interface ExternalUserClass{
    AccountEmployeeId:number,
    Password:string,
    Prefix:string,
    FirstName:string,
    LastName:string,
    EMailAddress:string,
    IsDeleted:boolean,
    IsDisabled:boolean,
    TimeZoneId:number | null,
    EmployeeTimeZoneId:number,
    ExternalUserClientId:number,
    EmployeeTypeId:number,
    EmailVerificationExpiryDate:Date | undefined
    EmailVerificationCode:string,
    IsEmailVerified:boolean,
    isSelected:number
}

const common = {    
    Password:"",
    Prefix:"",
    FirstName:"",
    LastName:"",
    MiddleName:"",
    EMailAddress:"",
    IsDeleted:false,
    IsDisabled:false,
    TimeZoneId:null,
    EmployeeTimeZoneId:null,
    ExternalUserClientId:null,
    EmployeeTypeId:null,
    EmailVerificationExpiryDate:new Date(),
    EmailVerificationCode:null,
    IsEmailVerified : false
  };

  
  export const ExternalUserInitialsForAdd = { ...common };
  
  export const ExternalUserInitialsForUpdate = {
    ...common,
    AccountEmployeeId: 0
  };


